import axios from 'axios';
import { BASE_URL } from '../config/apiUrls';

// Base API configuration
const api = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Không tự động thêm token nữa, để dev tự quyết định
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle global errors here
    return Promise.reject(error);
  }
);

export default api;

// Helper function để gọi API với token
export const apiWithToken = {
  get: async (url, config = {}) => {
    const { getToken } = await import('./authService');
    const token = await getToken();
    return api.get(url, {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${token}`
      }
    });
  },
  
  post: async (url, data, config = {}) => {
    const { getToken } = await import('./authService');
    const token = await getToken();
    return api.post(url, data, {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${token}`
      }
    });
  },
  
  put: async (url, data, config = {}) => {
    const { getToken } = await import('./authService');
    const token = await getToken();
    return api.put(url, data, {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${token}`
      }
    });
  },
  
  delete: async (url, config = {}) => {
    const { getToken } = await import('./authService');
    const token = await getToken();
    return api.delete(url, {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${token}`
      }
    });
  }
};
